<template>
  <div class="nav_bar">
    <div class="nav_container">
      <router-link to="/home" class="routermargin">
        <h1 class="nav_title">
          <span>B</span>
          <span>r</span>
          <span>o.</span>
          <span>M</span>
          <span>u</span>
          <span>s</span>
          <span>i</span>
          <span>c</span>
        </h1>
      </router-link>
      <ul>
        <router-link to="/track" class="routermargin">
          <a
            class="routerBtn"
            :class="{'activeRouter': this.activeRouter==='單曲搜尋'}"
            @click="activeRouterBtn(`單曲搜尋`)"
          >單曲搜尋</a>
        </router-link>
        <router-link to="/charts">
          <a
            class="routerBtn"
            :class="{'activeRouter':this.activeRouter==='熱門音榜'}"
            @click="activeRouterBtn(`熱門音榜`)"
          >熱門音榜</a>
        </router-link>
      </ul>

      <div class="search_container">
        <div class="search_radio">
          <div class="radio_container">
            <div
              class="search_type_container"
              :class="{'active_search_type':this.searchType==='track'}"
            >
              <button class="search_type_btn" @click="searchTypeChange('track')">歌曲</button>
            </div>
          </div>

          <div class="radio_container">
            <div
              class="search_type_container"
              :class="{'active_search_type':this.searchType==='artist'}"
            >
              <button class="search_type_btn" @click="searchTypeChange('artist')">歌手</button>
            </div>
          </div>
        </div>
        <div class="search_input">
          <input
            @keyup.enter="searchHandler"
            v-model="mySearchInput"
            type="text"
            placeholder="請輸入關鍵字"
            @change="searchInputChange"
          />
          <button type="button" @click="searchHandler">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navBar",
  data() {
    return {
      mySearchInput: this.$store.state.searchInput
    };
  },
  computed: {
    searchInput() {
      return this.$store.state.searchInput;
    },
    searchType() {
      return this.$store.state.searchType;
    },
    activeRouter() {
      return this.$store.state.activeRouter;
    }
  },
  created() {
    this.getToken();
  },
  methods: {
    getToken() {
      this.$store.dispatch("getToken");
    },
    searchInputChange() {
      let item = this.mySearchInput;
      this.$store.commit("SEARCHINPUT", item);
    },
    searchTypeChange(i) {
      this.$store.commit("SERACHTYPECHANGE", i);
    },
    searchHandler() {
      const vm = this;
      let path = vm.$router.history.current.path;
      if (path === "/track") {
        vm.$store.dispatch("getSearch");
      } else {
        vm.$store.commit("ACTIVEROUTER", "單曲搜尋");
        vm.$router.push("/track");
        vm.$store.dispatch("getSearch");
      }
    },
    activeRouterBtn(item) {
      const vm = this;
      vm.$store.commit("ACTIVEROUTER", item);
    }
  }
};
</script>

<style>
@import url("../assets/navBar.css");
@import url("../assets/navbar_RWD.css");
* {
  padding: 0;
  margin: 0;
  font-family: "Noto Sans TC", sans-serif;
}
</style>